/* src/app/calender/yearfour/yearfour.component.css */
body {
  font-family: Arial, sans-serif;
  margin: 0;
  padding: 0;
  background-color: rgb(255, 199, 162);
}
app-header {
  position: relative;
  z-index: 20;
  width: 100%;
}
.top {
  padding-top: 100px;
  display: flex;
  flex-direction: column;
}
.container {
  width: 90%;
  margin: 0 auto;
  padding: 20px;
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  height: 700px;
}
.header2 {
  position: relative;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
}
.heading {
  font-size: 24px;
  font-weight: 1000;
  color: rgb(255, 255, 255);
  padding-left: 00px;
}
.logo-mocktest {
  width: 180px;
  height: 40px;
}
.exam2 {
  color: #ffffff;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  font-size: 24px;
  border-radius: 10px;
  padding-right: 10px;
  padding-left: 10px;
}
.tabs {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;
  background-color: white;
  position: sticky;
  top: 0;
  z-index: 1;
}
.tab {
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  background-color: #f0f0f0;
  font-size: 16px;
  transition: all 0.3s ease;
}
.tab.active {
  background-color: #f38d19;
  font-weight: bold;
  color: white;
}
.timetable-wrapper {
  flex: 1;
  overflow-y: auto;
}
.timetable-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
.timetable-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.timetable-wrapper::-webkit-scrollbar-thumb {
  background: #dcd6ff;
  border-radius: 10px;
}
.timetable-wrapper::-webkit-scrollbar-thumb:hover {
  background: #bcb2ff;
}
.timetable-wrapper {
  scrollbar-width: thin;
  scrollbar-color: #dcd6ff #f1f1f1;
}
.timetable {
  margin-top: 20px;
}
.test-row {
  height: 200px;
  display: flex;
  align-items: center;
  background-color: #f6f6f6;
  margin: 10px 0;
  border-radius: 15px;
}
.test-info.enhanced {
  height: 200px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #FDCA93;
  border-radius: 15px 0 0 15px;
  text-align: center;
}
.testTopic {
  margin-bottom: 5px;
}
.test-date {
  width: 70px;
  font-size: 18px;
  font-weight: bold;
  margin-top: 20px;
  background-color: #fff;
  padding: 5px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.test-info.enhanced {
  border-left: 10px solid #e2e1e1;
  background-color: #ebebeb;
}
.testName {
  margin-bottom: 0px;
}
.test-centers {
  flex: 3;
  display: flex;
  gap: 20px;
  margin-left: 20px;
}
.center {
  background-color: #fafafa;
  padding: 10px;
  border-radius: 10px;
  border: 1px;
  border: 1px solid #b1b1b1;
  text-align: center;
}
.center.online {
  background-color: #e0f0d4;
  color: green;
}
.test-name {
  font-size: 16px;
  font-weight: bold;
}
.book-btn {
  width: 100%;
  display: inline-block;
  background-color: #f38d19;
  padding: 5px 15px;
  color: #fefefe;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.3s ease;
  text-align: center;
}
.book-btn:hover {
  background-color: #f2985d;
  color: white;
}
.test-menu {
  display: flex;
  flex-direction: row;
  align-self: center;
}
.btn-tab {
  padding: 10px 20px;
  border-radius: 20px;
  cursor: pointer;
  background-color: #f0f0f0;
  font-size: 16px;
  margin: 10px;
  transition: all 0.3s ease;
}
.btn-tab.active {
  background-color: #4780f1;
  font-weight: bold;
  color: white;
}
@media (max-width: 768px) {
  .container {
    padding: 10px;
    height: auto;
  }
  .header2 h1 {
    font-size: 18px;
    padding-left: 10px;
  }
  .header2 h2 {
    font-size: 14px;
    display: none;
  }
  .logo-mocktest {
    width: 80px;
    height: 30px;
  }
  .tabs {
    gap: 5px;
    flex-wrap: wrap;
  }
  .tab {
    padding: 8px 12px;
    font-size: 14px;
  }
  .timetable {
    margin-top: 10px;
  }
  .test-row {
    height: auto;
    flex-direction: column;
    padding: 10px;
    border-radius: 10px;
  }
  .test-info.enhanced {
    height: auto;
    flex: none;
    margin-bottom: 10px;
    border-radius: 10px;
    padding: 10px;
    text-align: center;
  }
  .test-date {
    width: auto;
    font-size: 16px;
    margin-top: 10px;
  }
  .testName {
    font-size: 16px;
  }
  .test-centers {
    flex-direction: column;
    gap: 10px;
    margin: 10px 0;
  }
  .center {
    padding: 10px;
    border: 1px solid #ccc;
    text-align: center;
  }
  .book-btn {
    display: block;
    margin-top: 10px;
    align-self: center;
  }
}
/*# sourceMappingURL=yearfour.component.css.map */
